<template>
    <div>
        <navbar :hide_search="true" :back_is_modal="true" @back-is-modal="backIsModal" />
        <a-spin :tip="$t('Loading...')" :spinning="getting_data">
            <div class="text-center custom-card">
                <div @click="backIsModal">
                    <label class="custom-close w-100 fs-16"> x close </label>
                </div>
                <div class="mt-32">
                    <label class="title w-100 fs-28"> {{ reward.title }} </label>
                </div>
                <div class="mt-24">
                    <label class="detail w-100 fs-22" v-html="reward.plivilege"> </label>
                </div>
                <div class="mt-32 mb-16">
                    <img
                        src="/resources/images/icon-countdown-reward.png"
                        :style="{
                            'vertical-align': $device == 'mobile' ? 'text-bottom' : 'middle',
                            width: $device == 'mobile' ? '10%' : 'auto',
                        }"
                    />
                    <span class="time fs-28">
                        {{ remaining_time.hours }} : {{ remaining_time.minutes }} :
                        {{ remaining_time.seconds }}
                    </span>
                </div>
            </div>
            <div class="text-center custom-card">
                <img
                    class="mt-32"
                    :src="reward_generate.barcode"
                    :style="{
                        width: $device == 'mobile' ? '100%' : '25%',
                    }"
                />
                <label class="fs-20" style="font-weight: 300; display: block">
                    {{ reward_generate.code }}
                </label>
                <img
                    :src="reward_generate.qrcode"
                    :style="{
                        width: $device == 'mobile' ? '60%' : '40%',
                    }"
                />
            </div>
            <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :data="modal_data" @on-confirm="onConfirmBack" @on-cancel="onModalCancel" />
        </a-spin>
    </div>
</template>
<script>
import navbar from '../../components/navbar';
import modalForm from './modalForm';
import moment from 'moment';
export default {
    components: {
        navbar,
        modalForm,
    },
    data: function () {
        return {
            getting_data: true,
            reward_generate: this.$route.query.reward_generate ? this.$route.query.reward_generate : {},
            reward: {},
            modal_visible: false,
            modal_data: {},
            current_date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            temp: 1,
            remaining_time: {
                hours: '00',
                minutes: '00',
                seconds: '00',
            },
            member_id: this.$route.params.member_id,
            priv_id: this.$route.params.priv_id,
            priv_id_from_sms: this.$route.params.priv_id_from_sms,
        };
    },
    created: function () {
        this.countDownTimer();
    },
    mounted() {
        this._mounted();
    },
    methods: {
        countDownTimer() {
            if (this.temp > 0) {
                setTimeout(() => {
                    var time = this.reward_generate.count_time ? Number(this.reward_generate.count_time / 60) : 0;
                    var countdown = moment(this.current_date).add(time, 'minutes');
                    var start = moment.utc();
                    var end = moment.utc(countdown);
                    var duration = moment.duration(end.diff(start));
                    var hours = duration.hours();
                    var minutes = duration.minutes();
                    var seconds = duration.seconds();
                    if (hours <= 0 && minutes <= 0 && seconds <= 0) {
                        this.temp = 0;
                        this.remaining_time = {
                            hours: '00',
                            minutes: '00',
                            seconds: '00',
                        };
                    } else {
                        if (hours >= 0) {
                            if (hours < 10) {
                                hours = '0' + hours;
                            }
                            if (minutes >= 0) {
                                if (minutes < 10) {
                                    minutes = '0' + minutes;
                                }
                                if (seconds < 10) {
                                    seconds = '0' + seconds;
                                }
                                this.temp = 1;
                                this.remaining_time = {
                                    hours: hours,
                                    minutes: minutes,
                                    seconds: seconds,
                                };
                            }
                        }
                    }
                    this.countDownTimer();
                }, 1000);
            }
        },
        _mounted: function () {
            this.getRewardDetail(() => (this.getting_data = false));
        },
        getRewardDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/sms/reward/detail/' + this.member_id + '/' + this.priv_id,
                    callback: (res) => {
                        if (res && res.result != 'errors') {
                            this.reward = res;
                        } else {
                            const errors = {
                                title: '',
                            };
                            for (const [, value] of Object.entries(res.errors)) {
                                errors.title += value[0];
                            }
                            this.$confirm({
                                title: errors.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        getRewardGenerate: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/sms/reward/generate/' + this.member_id + '/' + this.priv_id,
                    data: {
                        password: this.$route.query.password,
                    },
                    callback: (res) => {
                        if (res && res.result == 'errors') {
                            const errors = {
                                title: '',
                            };
                            for (const [, value] of Object.entries(res.errors)) {
                                errors.title += value[0];
                            }
                            this.$confirm({
                                title: errors.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        } else {
                            this.reward_generate = res;
                            this.countDownTimer();
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        backIsModal() {
            this.modal_data.step = 'back';
            this.modal_data.title = 'ท่านต้องการปิดหน้าต่างรหัสรับสิทธิ์';
            this.modal_data.message = 'เมื่อท่านปิดหน้าต่างรหัสรับสิทธิ์แล้ว จะไม่สามารถกลับมาดูรหัสรับสิทธิ์ได้อีก กรุณาศึกษาเงื่อนไขการใช้บริการก่อนกดรหัส รหัสที่ไม่ Active ไม่สามารถใช้งานได้';
            this.modal_visible = true;
            // console.log('modal_data', this.modal_data);
        },
        onModalCancel() {
            this.modal_visible = false;
        },
        onConfirmBack() {
            this.modal_visible = false;
            this.$router.replace({
                path: '/sms/reward/' + this.member_id + '/' + this.priv_id_from_sms,
            });
        },
    },
};
</script>
<style scoped>
.custom-card {
    margin: 16px;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
}
.custom-close {
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.title {
    font-weight: 600;
    margin: 0;
    color: #cc0000 !important;
    padding: 0px 12px;
}
.detail {
    margin: 0;
    color: #000 !important;
}
.time {
    font-weight: 600;
    margin: 0;
    color: #cc0000 !important;
    padding: 0px 6px;
}
</style>
